/**
 * Sprint7DashboardPage - Legacy Sprint 7 dashboard
 *
 * Surfaces the Sprint7Dashboard from @ferp/workflow-forms for admin/architect users.
 * Provides legacy sprint 7 components for backward compatibility.
 *
 * Route: /admin/sprint7
 */

import { Container, Title, Group, Badge, Text, ThemeIcon } from '@mantine/core';
import { IconBolt } from '@tabler/icons-react';

import { Sprint7Dashboard } from '@ferp/workflow-forms';
import { useAuth } from '@/auth/AuthContext';

export function Sprint7DashboardPage() {
  const { tenant } = useAuth();

  return (
    <Container size="xl" py="md">
      <Group justify="space-between" mb="lg">
        <Group gap="sm">
          <ThemeIcon size="lg" variant="light" color="gray">
            <IconBolt size={20} />
          </ThemeIcon>
          <div>
            <Title order={3}>Sprint 7 Dashboard</Title>
            <Text size="sm" c="dimmed">
              Legacy sprint 7 components and governance features
            </Text>
          </div>
        </Group>
        {tenant && (
          <Badge variant="light" color="gray">
            {tenant.name}
          </Badge>
        )}
      </Group>

      <Sprint7Dashboard />
    </Container>
  );
}

export default Sprint7DashboardPage;
